import React, { useEffect, useState, useContext } from 'react';
import { useCreditClient } from '../../../../services/credit';
import { useApp } from '../../../../state/app';
import { useUser } from '../../../../state/user';
import ElectronicConsent from './ElectronicConsent';
import PreTermsDocs from './PreTermsDocs';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';

export enum DocumentTypes {
  ElectronicDisclosure = 'e_disclosure',
  CreditTerms = 'soct',
  PrivacyPolicy = 'privacy_policy',
  RewardTerms = 'rewards_disclosure'
}

export default function PreTerms({
  moveToApplicationProcessing,
  handleCreditError,
  clearError
}) {
  const creditClient = useCreditClient();
  const authToken = useUser().registeredUser?.token || useApp().stargatewayKey;

  const [electronicConsentViewed, setElectronicConsentViewed] =
    useState<boolean>();
  const [docMap, setDocMap] = useState<Map<string, string>>();
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Credit Application Pre-Terms');
  }, []);

  const docContentByType = (
    type: DocumentTypes,
    docs: { type: string; content: string }[]
  ): string | undefined => {
    const document = docs.find(doc => {
      return doc.type === type;
    });

    return document?.content;
  };

  const acceptPreApprovalDocs = async () => {
    try {
      await creditClient.acceptPreApprovalDocs({
        authToken
      });
      await creditClient.submitCreditApplication({ authToken });
      clearError();
      moveToApplicationProcessing();
    } catch (error) {
      handleCreditError();
    }
  };

  useEffect(() => {
    creditClient
      .getApprovalDocuments({
        authToken,
        documentsType: 'pre-terms'
      })
      .then(docs => {
        const newState = new Map();
        newState.set(
          DocumentTypes.ElectronicDisclosure,
          docContentByType(DocumentTypes.ElectronicDisclosure, docs)
        );
        newState.set(
          DocumentTypes.CreditTerms,
          docContentByType(DocumentTypes.CreditTerms, docs)
        );
        newState.set(
          DocumentTypes.PrivacyPolicy,
          docContentByType(DocumentTypes.PrivacyPolicy, docs)
        );
        newState.set(
          DocumentTypes.RewardTerms,
          docContentByType(DocumentTypes.RewardTerms, docs)
        );
        setDocMap(newState);
      });
  }, []);

  return electronicConsentViewed ? (
    <PreTermsDocs docs={docMap} acceptPreApprovalDocs={acceptPreApprovalDocs} />
  ) : (
    <ElectronicConsent
      docs={docMap}
      setElectronicConsentViewed={setElectronicConsentViewed}
    />
  );
}
